import { Http } from '@mygpt/app/http';

export interface TranslateResponse {
  translations: Record<string, string>;
}

export interface SupportedLanguagesResponse {
  languages: string[];
}

/**
 * 将文本翻译为所有支持语言
 * @param text 原文
 * @param sourceLang 可选，原文语言 code（该语言直接用原文不再调模型）
 */
export const translateToAllLanguages = async (text: string, sourceLang?: string): Promise<TranslateResponse> => {
  const { post } = Http.use();
  const response = await post<TranslateResponse>('/translation/to-all-languages', {
    text,
    source_lang: sourceLang,
  });
  return response.data;
};

export const getSupportedLanguages = async (): Promise<SupportedLanguagesResponse> => {
  const { get } = Http.use();
  const response = await get<SupportedLanguagesResponse>('/translation/supported-languages');
  return response.data;
};
